import { CardBody, Col, Form, Input, Label, Row } from 'reactstrap';
import { InputCpfCnpj } from '../input_cpf';
import Cleave from 'cleave.js/react';
import { SelectInputCivilState } from '../selectInputCivilState';
import { ZipCodeInput } from '../zipCodeInput';
import { SelectInputWithSearchApi } from '../selectInput';
import { InputPhone } from '../input_tel';

export const ViewAssociatesDataRegister = ({
  validation,
  children,
  history,
  disabledCPF = false,
}) => {
  return (
    <Form
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit(e);
        return false;
      }}
    >
      <CardBody className="p-4">
        <Row>
          <Col md={12}>
            <div className="mb-3">
              <h5>Principal</h5>
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="name" className="form-label">
                Nome
              </Label>
              <Input
                type="text"
                className="form-control"
                id="nameInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.nameInput || ''}
              />
              {validation.touched.nameInput && validation.errors.nameInput ? (
                <p className="labelErrorValidation">
                  {validation.errors.nameInput}
                </p>
              ) : null}
            </div>
          </Col>

          <Col md={4}>
            <div className="mb-3">
              <label htmlFor="cleave-delimiters" className="form-label">
                CPF
              </label>
              <InputCpfCnpj
                id="cpfInput"
                isCPF={true}
                value={validation.values.cpfInput || ''}
                onChange={(e, type) => {
                  if (type === 'CPF') {
                    validation.handleChange(e);
                  }
                }}
                disabled={disabledCPF}
                onBlur={(e) => {
                  validation.handleBlur(e);
                }}
                invalid={
                  !!(validation.touched.cpfInput && validation.errors.cpfInput)
                }
              />
              {validation.touched.cpfInput && validation.errors.cpfInput ? (
                <p className="labelErrorValidation">
                  {validation.errors.cpfInput}
                </p>
              ) : null}
            </div>
          </Col>

          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="lastNameinput" className="form-label">
                RG
              </Label>
              <Input
                type="text"
                className="form-control"
                id="rgInput"
                maxLength={11}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.rgInput || ''}
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="mb-3">
              <label htmlFor="cleave-delimiters" className="form-label">
                Orgão
              </label>
              <Cleave
                options={{
                  delimiters: ['/'],
                  blocks: [3, 2],
                  uppercase: true,
                }}
                className="form-control"
                id="orgaoInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.orgaoInput || ''}
              />
            </div>
          </Col>

          <Col xs={12} md={3} lg={3}>
            <div className="mb-3">
              <Label htmlFor="motherName" className="form-label">
                Nome da Mãe
              </Label>
              <Input
                type="text"
                id="motherName"
                className="form-control"
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                value={validation.values.motherName}
              />
            </div>
          </Col>

          <Col md={3}>
            <div className="mb-3">
              <label htmlFor="cleave-delimiters" className="form-label">
                Data nascimento
              </label>
              <input
                type="date"
                className="form-control"
                id="birthdayInput"
                onChange={(e) => {
                  validation.handleChange(e);
                }}
                onBlur={validation.handleBlur}
                value={validation.values.birthdayInput || ''}
              />
              {validation.touched.birthdayInput &&
              validation.errors.birthdayInput ? (
                <p className="labelErrorValidation">
                  {validation.errors.birthdayInput}
                </p>
              ) : null}
            </div>
          </Col>
          <Col md={3}>
            <div className=" mb-3">
              <label htmlFor="cleave-delimiters" className="form-label">
                Gênero
              </label>
              <div className="d-flex">
                <div
                  className="form-check"
                  style={{
                    marginRight: '10px',
                  }}
                >
                  <input
                    type="radio"
                    className="form-check-input"
                    name="genderInput"
                    id="genderInputMale"
                    onChange={(e) => {
                      validation.handleChange(e);
                    }}
                    value="M"
                    checked={validation.values.genderInput === 'M'}
                  />
                  <Label htmlFor="genderInputMale" className="form-check-label">
                    Masculino
                  </Label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="genderInput"
                    id="genderInputFemale"
                    onChange={(e) => {
                      validation.handleChange(e);
                    }}
                    value="F"
                    checked={validation.values.genderInput === 'F'}
                  />
                  <Label
                    htmlFor="genderInputFemale"
                    className="form-check-label"
                  >
                    Feminino
                  </Label>
                </div>
              </div>
            </div>

            {validation.touched.genderInput && validation.errors.genderInput ? (
              <p className="labelErrorValidation">
                {validation.errors.genderInput}
              </p>
            ) : null}
          </Col>

          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="stateCivil" className="form-label">
                Estado Civil
              </Label>

              <SelectInputCivilState
                validation={validation}
                value={validation.values.stateCivilInput}
              />
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <Label htmlFor="emailidInput" className="form-label">
                Profissão
              </Label>
              <Input
                type="text"
                className="form-control"
                id="jobInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.jobInput || ''}
              />
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="address1ControlTextarea" className="form-label">
                Observações
              </Label>
              <textarea
                className="form-control"
                id="obsInput"
                rows="3"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.obsInput || ''}
              ></textarea>
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <h5>Contato</h5>
            </div>
          </Col>
          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="citynameInput" className="form-label">
                Email
              </Label>
              <Input
                type="email"
                className="form-control"
                id="emailInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.emailInput || ''}
                style={{
                  textTransform: 'lowercase',
                }}
              />
            </div>
          </Col>

          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="phoneInput" className="form-label">
                Celular
              </Label>
              <InputPhone
                id="phoneInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.phoneInput || ''}
              />
              {validation.touched.phoneInput && validation.errors.phoneInput ? (
                <p className="labelErrorValidation">
                  {validation.errors.phoneInput}
                </p>
              ) : null}
            </div>
          </Col>

          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="citynameInput" className="form-label">
                Telefone
              </Label>
              <InputPhone
                id="telInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.telInput || ''}
              />
            </div>
          </Col>

          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="citynameInput" className="form-label">
                Whatsapp
              </Label>
              <InputPhone
                id="whatsappInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.whatsappInput || ''}
              />
            </div>
          </Col>

          <Row md={12}>
            <Col md={6}>
              <div>
                <div className="form-check form-switch mb-3 form-switch-md">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="canSendMessageSelect"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    checked={validation.values.canSendMessageSelect}
                  />
                  <Label
                    className="form-check-label"
                    htmlFor="canSendMessageSelect"
                  >
                    Associado aceita receber mensagens por e-mail/whatsapp/SMS
                  </Label>
                </div>
              </div>
            </Col>

            <Col md={12}>
              <div className="mb-3">
                <h5>Endereço</h5>
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  CEP
                </Label>
                <ZipCodeInput
                  className="form-control"
                  id="zipInput"
                  onChange={validation.handleChange}
                  changeInputs={(e) => {
                    validation.setValues({
                      ...validation.values,
                      zipInput: e.cep,
                      streetInput: e.logradouro,
                      neighborhoodInput: e.bairro,
                      address2Input: e.complemento,
                      cityInput: {
                        label: `${e.localidade} - ${e.uf} `,
                        value: e.ibge,
                      },
                    });
                  }}
                  onBlur={(e) => {
                    validation.handleBlur(e);
                  }}
                  value={validation.values.zipInput || ''}
                />

                {validation.touched.zipInput && validation.errors.zipInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.zipInput}
                  </p>
                ) : null}
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  Logradouro
                </Label>
                <Input
                  className="form-control"
                  id="streetInput"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.streetInput || ''}
                />
                {validation.touched.streetInput &&
                validation.errors.streetInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.streetInput}
                  </p>
                ) : null}
              </div>
            </Col>

            <Col md={3}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  Número
                </Label>
                <Input
                  className="form-control"
                  id="numberInput"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.numberInput || ''}
                />
                {validation.touched.numberInput &&
                validation.errors.numberInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.numberInput}
                  </p>
                ) : null}
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  Complemento
                </Label>
                <Input
                  className="form-control"
                  id="address2Input"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.address2Input || ''}
                />
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  Bairro
                </Label>
                <Input
                  className="form-control"
                  id="neighborhoodInput"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.neighborhoodInput || ''}
                />
                {validation.touched.neighborhoodInput &&
                validation.errors.neighborhoodInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.neighborhoodInput}
                  </p>
                ) : null}
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <Label htmlFor="cityInput" className="form-label">
                  Cidade
                </Label>
                <SelectInputWithSearchApi validation={validation} />
                {validation.touched.cityInput && validation.errors.cityInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.cityInput}
                  </p>
                ) : null}
              </div>
            </Col>

            <Col md={6}>
              <div className="mb-3">
                <Label htmlFor="ForminputState" className="form-label">
                  Ponto de referência
                </Label>
                <Input
                  className="form-control"
                  id="pointInput"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.pointInput || ''}
                />
              </div>
            </Col>

            <Col lg={4} md={6}>
              <div className="mt-4 mt-md-0">
                <div>
                  <div className="form-check form-switch mb-3 form-switch-md">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="isActiveSelect"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      checked={validation.values.isActiveSelect}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="isActiveSelect"
                    >
                      Ativo
                    </Label>
                  </div>
                </div>

                <div>
                  <div className="form-check form-switch mb-3 form-switch-md">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="isDiedSelect"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      checked={validation.values.isDiedSelect}
                    />
                    <Label className="form-check-label" htmlFor="isDiedSelect">
                      Óbito
                    </Label>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </CardBody>

      {children}
    </Form>
  );
};
